import Spinner from 'src/javascripts/components/utilities/Spinner';
import {filterTypeahead} from 'src/javascripts/components/typeaheads/TypeaheadBloodhounds';
import {noResultsTemplate, genericDisplayTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';
import 'src/javascripts/vendor/typeahead.jquery';
import 'src/javascripts/vendor/bloodhound';

// Must define Bloodhound explicitly here
// https://stackoverflow.com/questions/30750916/how-to-reference-typeahead-and-bloodhound-when-loading-npm-typeahead-js
const Bloodhound = require('src/javascripts/vendor/bloodhound');

export default class AdminDataFrameworksMetricWeightsEdit {

  constructor() {}

  render() {
    const accountUrl = $('#metrics_search').data('account-url');

    // Display metric results
    const metricDisplayAllTemplate = (name, description, id, accountName) => '<div class=\'card mb-2 clickable bg-gray100 metric-search-option\' data-metric-name=\'' + name + '\' data-metric-id=\'' + id + '\'>' +
      '<div class=\'card-body\'>' +
      '<div class="mb-1 d-flex w-100">' +
      '<div class="text-gray600 mr-3" style=\'font-size: 13px; font-family: Inter;\'>' + name + '</div>' +
      '<div class=\'text-gray500 ml-auto text-uppercase\' style=\'font-size: 12px; font-family: Inter;\'>' + accountName + '</div>' +
      '</div>' +
      '<div class=\'text-gray500\' style=\'font-size: 11px; font-family: Inter;\'>' + description + '</div>' +
      '</div>';

    // Metrics search
    let metricsBloodhound = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      remote: {
        url: '/' + accountUrl + '/data/metrics?query=%QUERY',
        wildcard: "%QUERY",
        cache: false,
        transform: function(d) { return d.data; }
      }});

    metricsBloodhound.initialize();
    $('#metrics_search').typeahead({
      hint: true,
      highlight: true,
      minLength: 0,
      classNames: {
        menu: 'd-none' // add class name to menu so default dropdown does not show
      }
    }, {
      name: 'metrics',
      display: 'name',
      limit: 351,
      source: metricsBloodhound.ttAdapter(),
      menu: '#metricsSearchResults'
    });

    $('#metrics_search').on('typeahead:render', function (e, datum) {
      $('#metricsSearchResults').empty();
      $('#metricsSearchResults').closest('.form-group').removeClass('d-none');
      Spinner($('#metricsSearchResults'));
      var suggestions = Array.prototype.slice.call(arguments, 1);
      if (suggestions.length) {

        //empty suggestion div to display results
        for (var c = 0; c < suggestions.length; c++) {

          // Set template to render
          let template;
          let accountName = suggestions[c].account;
          if (accountName === null) {accountName = ''}
          template = metricDisplayAllTemplate(suggestions[c].name, suggestions[c].description, suggestions[c].record_id, accountName);

          // Append to metrics search list
          $('#metricsSearchResults').append(template);

        }

        // Remove spinner
        $('#metricsSearchResults').find('.spinner-container').remove();

      } else {

        // Append to metrics search list
        $('#metricsSearchResults').find('.spinner-container').remove();
        $('#metricsSearchResults').empty().append("No metrics found")
        
      }

      // Update selected on click 
      $('.metric-search-option').click(function(ev) {
        let qid = $(this).attr('data-metric-id');
        let qText = $(this).attr('data-metric-name');
        $('#metric_id').val(qid);
        $('#metrics_search').val(qText);
        $('#metricsSearchResults').closest('.form-group').addClass('d-none');
      });

    });
    
    // On clear typeahead
    $('.clear-metrics-typeahead').click(function() {
      $('#metric_id').val("");
      $('#metrics_search').typeahead("val", "");
      $('#metrics_search').focus();
      $('#metricsSearchResults').closest('.form-group').removeClass('d-none');
    })

    // Focus metrics
    if ($('#metrics_search').length !== 0) {
      $('#metrics_search').focus();
    }

  }

}







